import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IChapter } from '@/interface';
import { fetchChapterList } from '@/services/chapter';

export interface SpaceState {
  chapterList: IChapter[];
}

const initialState: SpaceState = {
  chapterList: [],
};

export const getChapters = createAsyncThunk(
  'chapter/list',
  fetchChapterList,
);

export const chapter = createSlice({
  name: 'chapter',
  initialState,
  reducers: {
    clearChapters() {
      return initialState;
    },
    delChapter(state, { payload }: PayloadAction<{ delId: string }>) {
      return {
        ...state,
        chapterList: state.chapterList.filter(({ id }) => id !== payload.delId),
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getChapters.fulfilled, (state, { payload }) => {
      if (!payload) {
        return initialState;
      }
      return {
        ...state,
        chapterList: payload.list,
      };
    });
  },
});

export const { clearChapters, delChapter } = chapter.actions;

export default chapter.reducer;
